import Vue from 'vue'
import 'flatpickr/dist/flatpickr.css'
import VueFlatPicker from 'vue-flatpickr-component'

Vue.use(VueFlatPicker)
